import axiosApiInstance from "../../interceptors/axiosApiInstance";
import { BASE_URL } from "../config";

const VersionService = {
    getAbout: async function () {
        try {
            const response = await axiosApiInstance.get(await BASE_URL + `/version/about`);
            return response.data;
        } catch (error) {
            return error.response ? error.response.data : undefined;
        }
    },
}

export default VersionService;